import { DataExchangeApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useDataExchangeAPI(): DataExchangeApi {
  return new DataExchangeApi(apiConfig);
}
